import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import LoadsPage from "components/LoadsPage";
import {
  useAddEWHUsageMutation,
  useGetEWHUsageByCommunityIdPaginationQuery,
} from "state/ewh/ewhApiSlice";

function ManageEWHUsage({ noWrapper }) {
  const { t } = useTranslation(["internalLoads"]);
  return (
    <LoadsPage
      title={t("pages.ewh_usage.title")}
      subtitle={t("pages.ewh_usage.subtitle")}
      taskType="EWH_USAGE"
      templateHref="/docs/template_ewh_usage.csv"
      addMutation={useAddEWHUsageMutation}
      noWrapper={noWrapper}
      table={{
        query: useGetEWHUsageByCommunityIdPaginationQuery,
        resourceField: "ewh_id",
        resourceLabel: t("pages.ewh_usage.table.columns.ewh"),
        resourceType: "EWH",
        valueLabel: {
          field: "duration",
          label: t("pages.ewh_usage.table.columns.duration_minutes"),
        },
        valueDigits: 2,
      }}
    />
  );
}

ManageEWHUsage.propTypes = {
  noWrapper: PropTypes.bool,
};

ManageEWHUsage.defaultProps = {
  noWrapper: false,
};

export default ManageEWHUsage;
